import axios from 'axios'
import router from '@/router'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
    airport: [],
    flight: {
      airport: '',
      schedule: [],
      detail: {},
      offset: 0
    }
  },
  mutations: {
  },
  actions: {
    getAirport ({ state, dispatch }) {
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-file&siteid=${API.SITE_INFO.site}&file=flightinfo/airport.json`).then(res => {
        state.airport = res.data.message.display
        return res.data.message
      }).catch((ex) => {
        console.log(ex)
        const ln = router.currentRoute.params.ln
        router.replace({ path: `/${ln}` })
      })
    },
    getAirportInfo ({ state, dispatch }, airport) {
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-airport-info&airport=${airport}`).then(res => {
        console.log(res.data.message)
        return res.data.message
      }).catch((ex) => {
        console.log(ex)
        const ln = router.currentRoute.params.ln
        router.replace({ path: `/${ln}` })
      })
    },
    getFlightSchedule ({ state, dispatch }, airport) {
      const offset = state.flight.offset
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-flight-schedule&airport=${airport}&offset=${offset}`).then(res => {
        state.flight.schedule = state.flight.schedule.concat(res.data.message.items)
        state.flight.offset = res.data.message.offset
        return res.data.message
      }).catch((ex) => {
        console.log(ex)
        const ln = router.currentRoute.params.ln
        router.replace({ path: `/${ln}` })
      })
    },
    getScheduleDetail ({ state, dispatch }, data) {
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-flight-info&ident=${data.ident}&departurets=${data.departurets}`).then(res => {
        console.log(res.data.message)
        state.flight.detail = res.data.message
        return res.data.message
      }).catch((ex) => {
        console.log(ex)
        const ln = router.currentRoute.params.ln
        router.replace({ path: `/${ln}` })
      })
    }
  },
  getters: {
    getAirport: state => state.airport,
    getAirportInfo: state => state.flight.airportInfo,
    getFlightSchedule: state => state.flight.schedule,
    getScheduleDetail: state => state.flight.detail
  }
}
